import React from "react";
import StatusTag from "../../../components/StatusTag";
import PackageActions from "./actions/PackageActions";
import styles from "./PackageWithTracking.module.scss";

// Generic Package with tracking component, with
// - package number (within order)
// - tracking number
// - skus (usually one but could be 5 gallon + its packaging)
// - optionnal action
const PackageWithTracking = (props) => {
  const {
    warehouseId, pack, action,
    className, withState, detailView
  } = props;
  const skus = pack.get("skus").toJS();
  const state = pack.get("state");
  const displayAlert = pack.get("alert");

  const getLabel = (skuWithQuantity) => `${skuWithQuantity.quantity}X ${skuWithQuantity.sku}`;
  const skusElems = skus.map((skuWithQuantity) => (
    // Within a package, sku can act as key
    <div key={skuWithQuantity.sku} className={styles.sku}>{getLabel(skuWithQuantity)}</div>
  ));

  const classes = [
    styles.module,
    className,
    displayAlert ? styles.alert : null,
    // For the .bgColorTheme, an ancestor needs to be set with the state
    state,
  ];

  const statusElem = withState && (
    <StatusTag color="bgColorTheme"
      text={state.replace(/([A-Z])/g, " $1")} />
  );
  
  const idAndTrackingNr = `${pack.get("id")} / ${pack.get("trackingNr") || "--"}`;

  return (
    <div className={classes.join(" ")}>
      <div className={styles.infos}>
        <div className={styles.ids}>{ idAndTrackingNr }</div>
        { skusElems }
        { statusElem }
      </div>
      <div className={styles.actions}>
        { action }
        <PackageActions warehouseId={warehouseId} pack={pack} detailView={detailView} />
      </div>
    </div>
  );
}

export default PackageWithTracking;